import { ChangeDetectorRef, Component } from '@angular/core';
import { StayListComponent } from 'app/layout/common/list-stay/stay-list.component';
import { ActivityListComponent } from 'app/layout/common/list-activity/activity-list.component';
import { FlightListComponent } from 'app/layout/common/list-flight/flight-list.component';
import { LandingType01Component } from '../../landing/landing-type01/landing-type01.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, NgIf } from '@angular/common';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { TFMService } from 'app/mock-api/tfm.service';
import { PopularPackagesComponent } from 'app/modules/admin/quote-details/packages/popular-packages/popular-packages.component';
import { TransferListComponent } from 'app/layout/common/list-transfer/transfer-list.component';

@Component({
  selector: 'app-search-results-type01',
  standalone: true,
  imports: [StayListComponent,ActivityListComponent,FlightListComponent,TransferListComponent,LandingType01Component, NgIf,DestinationListType01Component,PopularPackagesComponent],
  templateUrl: './search-results-type01.component.html',
  styleUrl: './search-results-type01.component.scss'
})
export class SearchResultsType01Component {
  public view: any = {};

  constructor(private _tfmService: TFMService, private _tfmCartService: TFMCartService, private _cd: ChangeDetectorRef, private _router: Router, private _route: ActivatedRoute, private location: Location) {  
    var state : any = this.location.getState();
    this._tfmService.log(state);
    this.view = state.view;
    this.view.type = state.type;

    this.view.transfersReceived = 0;

    if (this.view.type == "package") {
      this.view.search.method = "dynamic";
    }
  }

  public tripChanged(tripData) {

    this.view.trip = tripData;

    this._tfmCartService.updateTrip(this.view.trip);

    //this.getInterestingInfo();
  }
  public searchChanged(searchData) {
    this.view.search = searchData;

    if (this.view.search)
      this.view.search.method = "dynamic";
  }

  public resultChanged(e, pointIndex = 0) {
    this._tfmService.log("resultChanged 1", e);

    if (e) {
      if (e.trip && e.trip.points && e.trip.points[0].flights && e.trip.points[0].flights.length > 0) {
        this.view.search.flights = e.trip.points[0].flights;
      }
      
      if (e.data && e.data.transfers) {
        if (!this.view.search.transfers) {
          this.view.search.transfers = [];
        }

        e.data.transfers.forEach(t => {
          this.view.search.transfers.push(t);
        });
        this._tfmService.log("transfers", e.data.transfers, pointIndex);

        this.view.transfersReceived += 1;
        this._cd.detectChanges();
      }
    }
  }
}
